import { render, staticRenderFns } from "./androidform.vue?vue&type=template&id=5c36b6dc&"
import script from "./androidform.vue?vue&type=script&lang=ts&"
export * from "./androidform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports